import { OidcProvider } from '@/context';
import {
  SSO_AUTHORITY,
  SSO_CALLBACK,
  SSO_CLIENT_ID,
  SSO_LOGOUT_CALLBACK,
  SSO_SCOPE,
} from '@/utils/constants';
import { WebStorageStateStore } from 'oidc-client-ts';
import secureLocalStorage from 'react-secure-storage';

const configuration: React.ComponentProps<typeof OidcProvider>['configuration'] = {
  client_id: SSO_CLIENT_ID,
  redirect_uri: SSO_CALLBACK,
  post_logout_redirect_uri: SSO_LOGOUT_CALLBACK,
  userStore: new WebStorageStateStore({ store: secureLocalStorage as Storage }),
  scope: SSO_SCOPE,
  authority: SSO_AUTHORITY,
  loadUserInfo: true,
  automaticSilentRenew: false,
  ui_locales: `${window.ssoUiLocale} en`,
};

export default configuration;
